import { Plus } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ContactGroupType } from 'contacts/enums';
import { IContactGroup } from 'contacts/types';
import { Button } from 'core/components';
import { Color } from 'theme/enums';

import { UpsertLocation } from './UpsertLocation';

interface IProps {
  contactGroup?: IContactGroup;
  contactGroupType?: ContactGroupType;
  onSubmitSuccess?: () => void;
}

export const UpsertLocationButton = ({
  contactGroup,
  contactGroupType = ContactGroupType.CUSTOMER,
  onSubmitSuccess,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button
        text={t('buttonLabelAddLocation')}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />

      <UpsertLocation
        isOpen={isOpen}
        onClose={onClose}
        contactGroup={contactGroup}
        contactGroupType={contactGroupType}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
